import React, { createContext, useMemo, useContext } from 'react'

// Create context with default value
export const ScreenBuilderProjectContext = createContext(undefined)

// Custom hook to use the project context with error handling
export const useScreenBuilderProjectContext = () => useContext(ScreenBuilderProjectContext)

// Provider component to wrap application parts that need access to project context
export const ScreenBuilderProjectContextProvider = ({ project, children }) => {
  // Extract and process product categories from project data
  const projectContext = useMemo(() => {
    // Default empty set of categories
    const categoriesSet = new Set()

    // Process products if they exist in the project
    if (project?.products && Array.isArray(project.products)) {
      // Extract categories from each product
      project.products.forEach((product) => {
        if (product.category) {
          // Split by comma and process each category
          const categories = product.category.split(',')
          categories.forEach((category) => {
            const trimmedCategory = category.trim()
            if (trimmedCategory) {
              categoriesSet.add(trimmedCategory)
            }
          })
        }
      })
    }

    // Convert set to array for the context value
    return {
      productCategories: Array.from(categoriesSet).sort(),
    }
  }, [project])

  return <ScreenBuilderProjectContext.Provider value={projectContext}>{children}</ScreenBuilderProjectContext.Provider>
}
